module.exports = __webpack_public_path__ + "media/images/official/kv_sp3-dc5afa441c00c015159a3c5d2a556d64.webp";